<template>
  <div class="home-slide-show">
    <div class="slideshow">
      <div
        class="slide"
        v-for="(slide, index) in slides"
        :key="index"
        :class="{ active: index === currentSlide }"
      >
        <a :href="slideUrl">
          <img :src="slide.image_url" class="banner" alt="Slides Image" />
        </a>
      </div>

      <!-- Move pagination outside of slides -->
      <div class="slideshow-pagination" v-if="slides.length > 1">
        <div
          class="slideshow-pagination-dot"
          v-for="(slide, index) in slides"
          :key="index"
          :class="{ active: index === activeIndex }"
          @click="setActive(index)"
        ></div>
      </div>
    </div>
  </div>
</template>
  
<script>
import titleMixin from "@/mixins/TitleMixins.js";
import axios from "axios";

export default {
  name: "slide-show",
  mixins: [titleMixin],

  data() {
    return {
      slides: [],
      currentSlide: 0,
      slideInterval: null,
      activeIndex: 0,
    };
  },

  mounted() {
    this.loadBanners();
    this.startSlideshow();
  },

  computed: {
    slideUrl() {
      if (this.slides[this.currentSlide]) {
        if (!this.slides[this.currentSlide].url) {
          return "/promotion";
        }
        return this.slides[this.currentSlide].url;
      }
      return "";
    },
  },

  methods: {
    setActive(index) {
      this.activeIndex = index;
      this.currentSlide = index;
    },

    startSlideshow() {
      this.slideInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.activeIndex = this.currentSlide;
      }, 5000);
    },

    loadBanners() {
      let preview = this.$route.query.preview ? this.$route.query.preview : 0;
      axios.get("/banners/home/main?preview=" + preview).then((response) => {
        this.slides = response.data.data.banners;
      });
    },
  },

  beforeUnmount() {
    clearInterval(this.slideInterval);
  },
};
</script>

<style scoped>
.home-slide-show {
  width: 100%;
  margin: 0 auto;
}

.slideshow {
  position: relative;
  width: 100%;
  max-width: 1920px;
  max-height: 800px;
  margin: 80px 0 0 auto;
  overflow: hidden;
  background: #000;
}

/* Desktop: maintain aspect ratio */
@media (min-width: 769px) {
  .slideshow {
    aspect-ratio: 2.4 / 1; /* 1920:800 ratio */
    max-height: 800px;
  }

  .slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}



.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.slide.active {
  opacity: 1;
  z-index: 1;
}

.slide a {
  display: block;
  width: 100%;
  height: 100%;
}

.slide img {
  display: block;
  border: none;
}

/* Pagination styles */
.slideshow-pagination {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.slideshow-pagination-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.slideshow-pagination-dot:hover {
  background-color: rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}

.slideshow-pagination-dot.active {
  background-color: white;
  transform: scale(1.2);
}

/* Mobile: show full image without cropping */
@media (max-width: 1400px) {
  .slideshow {
    aspect-ratio: auto; /* Let the image determine the height */
    max-height: none;
    background: transparent;
  }

  .slide img {
    width: 100%;
    height: auto;
    object-fit: contain; /* Show full image without cropping */
  }

  .slide {
    position: relative; /* Change from absolute to relative */
    height: auto;
    margin-top: 8%;
  }

  .slide:not(.active) {
    display: none; /* Hide inactive slides on mobile */
  }

  .slide.active {
    display: block;
  }
}

/* Mobile: show full image without cropping */
@media (max-width: 768px) {
  .slideshow {
    aspect-ratio: auto; /* Let the image determine the height */
    max-height: none;
    background: transparent;
  }

  .slide img {
    width: 100%;
    height: auto;
    object-fit: contain; /* Show full image without cropping */
  }

  .slide {
    position: relative; /* Change from absolute to relative */
    height: auto;
    margin-top: 20%;
  }

  .slide:not(.active) {
    display: none; /* Hide inactive slides on mobile */
  }

  .slide.active {
    display: block;
  }
}

/* Very small screens */
@media (max-width: 480px) {
  .slideshow-pagination {
    bottom: 10px;
    gap: 8px;
  }

  .slideshow-pagination-dot {
    width: 10px;
    height: 10px;
  }
}
</style>